export const TeamMember = ({ person, flipped }) => (
  <div className="grid md:grid-cols-12 gap-8 md:gap-16 items-start" data-testid={`team-member-${person.name}`}>
    <div className={`md:col-span-5 overflow-hidden ${flipped ? "md:order-2" : ""}`}>
      <img
        src={person.img}
        alt={person.name}
        loading="lazy"
        className="w-full h-[420px] md:h-[600px] object-cover hover:scale-[1.02] transition-transform duration-[900ms]"
        style={{ filter: "grayscale(12%)" }}
      />
    </div>
    <div className={`md:col-span-7 ${flipped ? "md:order-1 md:col-start-1" : "md:col-start-7 md:col-span-6"}`}>
      <h3 className="font-display text-[26px] md:text-[34px] leading-none tracking-tight">{person.name}</h3>
      <p className="font-label text-[10px] text-[#8b8578] mt-4 mb-7 pb-6 border-b border-[rgba(35,33,28,0.14)]">{person.role}</p>
      <p className="text-[#5f5a50] text-[14px] leading-relaxed font-light">{person.bio}</p>
      <ul className="mt-8 space-y-1.5">
        {person.cred.map((c) => (
          <li key={c} className="font-label text-[10px] text-[#8b8578]">{c}</li>
        ))}
      </ul>
    </div>
  </div>
);
